import { getBookingMachineCode } from '../bookingDisplay';
import {
  inferWalletTxnCategory,
  inferWalletTxnChannel,
  inferWalletTxnStatus,
  walletTxnCategoryLabel,
} from '../ledger/mapWalletTransactions';
import {
  channelLabel,
  cleanDescription,
  formatInrPlain,
  formatReconDate,
  formatReconDateTime,
  statusLabel,
} from './formatters';
import { computeBookingTaxQuote } from '../gst/gstRules';

export function enrichTransactionRow(tx, ctx = {}) {
  const {
    clientLookup = {},
    bookingByRef = {},
    machineLookup = null,
    inferChannel = inferWalletTxnChannel,
    inferStatus = inferWalletTxnStatus,
  } = ctx;

  const amount = Math.abs(Number(tx.amount || 0));
  const taxQuote = computeBookingTaxQuote(amount);
  const gst = taxQuote.gst;
  const total = taxQuote.grandTotal;
  const type = String(tx.type || '').toLowerCase();
  const channel = inferChannel(tx, { bookingByRef });
  const status = inferStatus(tx);
  const category = inferWalletTxnCategory(tx, clientLookup, { bookingByRef });
  const ref = tx.reference || tx.ref || '';
  const client = clientLookup[tx.user_id] || {};
  const booking = ref && bookingByRef[ref] ? bookingByRef[ref] : null;
  const machineCode = booking ? getBookingMachineCode(booking, machineLookup) : '—';

  return {
    ...tx,
    displayDate: formatReconDate(tx.created_at),
    displayDateTime: formatReconDateTime(tx.created_at),
    receiptRef: ref || '—',
    clientName: client.name || client.company || 'Unknown Client',
    clientCompany: client.company
      || client.companyName
      || tx.client?.company
      || tx.client?.companyName
      || tx.companyName
      || tx.company
      || client.name
      || '—',
    channel,
    channelLabel: channelLabel(channel),
    category,
    categoryLabel: walletTxnCategoryLabel(category),
    status,
    statusLabel: statusLabel(status),
    typeLabel: type === 'credit' ? 'Credit' : 'Debit',
    amount,
    credit: type === 'credit' ? amount : 0,
    debit: type === 'debit' ? amount : 0,
    gst,
    totalInclGst: total,
    amountFormatted: formatInrPlain(amount),
    gstFormatted: formatInrPlain(gst),
    totalFormatted: formatInrPlain(total),
    descriptionClean: cleanDescription(tx.description),
    machineCode: machineCode !== 'N/A' ? machineCode : '—',
  };
}

export function enrichTransactionRows(transactions = [], ctx = {}) {
  return (transactions || []).map((tx) => enrichTransactionRow(tx, ctx));
}
